
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet';
import Time from '../UI/Time';
import TimeEnd from '../UI/TimeEnd';
import s from './index.module.css';
import classNames from 'classnames';

const Daily = ({ regularity, changeRegularity, timeRange, inactiveCheckbox, hideInactiveDays }) => {
    return (
        <div className={s.checkboxWrapper}> 
            
            {
                regularity?.daily?.map((day, index) => {
                    if(hideInactiveDays && !day.active){
                        return <></>;
                    }
                    return (
                        <div key={day.day} className={s.lineWpapper}>
                            {
                                inactiveCheckbox ? (
                                    <span className={s.text}>{day.label}</span>
                                ) : (
                                    <CheckboxViolet 
                                        onClick = {() => changeRegularity(index)} 
                                        blockClassName={classNames(s.blockCheckboxViolet, 'checkbox')}
                                        className={s.checkboxViolet}
                                        value={day.active}
                                        text={day.label} />
                                )
                            }
                            
                            {
                                day.active && <Time 
                                                changeRegularity={changeRegularity} 
                                                index={index} 
                                                minutes={day.minutes} 
                                                hour={day.hour} 
                                                firstField='daily'
                                             />
                            }
                            {
                                day.active && timeRange && '-'
                            }
                            {
                                day.active && timeRange && (
                                    <TimeEnd
                                        changeRegularity={changeRegularity} 
                                        index={index} 
                                        minutesEnd={day.minutesEnd} 
                                        hourEnd={day.hourEnd} 
                                        firstField='daily'
                                    />
                                )
                            }
                            
                            
                        </div>
                    )
                })
            }
        </div>
    )
}

export default Daily;